import { head, isEmpty, propEq } from 'ramda';

import { ModuleTabOptions } from './ModulePageConfigProvider.types';

export const getTabBySlug = (tabId: string | undefined, tabs: ModuleTabOptions[]) => {
  if (isEmpty(tabs)) {
    return undefined;
  }
  return tabId ? tabs.find(propEq(tabId, 'slug')) : head(tabs);
};
